<template lang="pug">
RewardsBorder(:type="type").rewards-group
  .rewards-group__title {{ rewardTitle }}
  .rewards-group__list
    RewardsItem(
      v-for="reward_id in rewardsList",
      :key="reward_id",
      :rewardId="reward_id"
    )
</template>

<script>
import RewardsBorder from "./RewardsBorder";
import RewardsItem from "./RewardsItem";

export default {
  name: "RewardsGroup",
  components: {
    RewardsBorder,
    RewardsItem,
  },
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    rewardsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rewardTitle() {
      return this.$t(`promo.rewards.titles.${this.type}`)
    },
  },
};
</script>
